// generated by genversion
export var version = '4.1.2';
//# sourceMappingURL=version.js.map